import React from 'react';
import {Image, Point} from '../../admin/artisticobjects/types/Image';
import {getFeatureFlag} from '../config/featureFlags';

export const getImageUrl = (imagePath: string): string => {
  return `/storage/${imagePath}`;
};

export const getThumbnailUrl = (image: Image): string => {
  const path = image.thumbnailPath || image.path;
  return getImageUrl(path);
};

export const getObjectPosition = (focalPoint?: Point, size?: {
  width: number;
  height: number
}): React.CSSProperties => {
  const focalPointsEnabled = getFeatureFlag('focalPoints').enabledInListings;
  const yPerc = focalPointsEnabled && focalPoint && size ? (focalPoint.y / size.height) * 100 : 50;
  const xPerc = focalPointsEnabled && focalPoint && size ? (focalPoint.x / size.width) * 100 : 50;
  return {objectPosition: `${xPerc}% ${yPerc}%`};
};
